import React, { ChangeEvent, FunctionComponent, MouseEvent, Ref } from 'react';

import { MessageType } from '@savgroup-front-common/types';

import { safeFormattedIntlString } from '../../formatters';
import { CheckIcon, MinusIcon } from '../../protons/icons';

import {
  $CheckboxInput,
  $CheckContainer,
  $StyledCheckbox,
} from './Checkbox.styles';

export interface CheckboxNakedProps {
  disabled?: boolean;
  danger?: boolean;
  onChange?: ((event: ChangeEvent<HTMLInputElement>) => void) | undefined;
  onClick?: ((event: MouseEvent<HTMLInputElement>) => void) | undefined;
  checked?: boolean;
  defaultChecked?: boolean;
  isIndeterminate?: boolean;
  type?: 'checkbox' | 'radio';
  name: string;
  value?: string | undefined;
  dataTestId?: string;
  hasMultiple?: boolean;
  hasDescription?: boolean;
  isFlexAlign?: boolean;
  isHidden?: boolean;
  ariaLabel?: string;
  title?: string | MessageType;
}

export interface CheckboxNakedWithRefProps extends CheckboxNakedProps {
  forwardedRef: Ref<HTMLInputElement>;
}

const CheckboxNaked: FunctionComponent<
  React.PropsWithChildren<CheckboxNakedWithRefProps>
> = ({
  disabled = false,
  danger = false,
  type = 'checkbox',
  forwardedRef,
  name,
  onChange,
  checked,
  value,
  dataTestId,
  isIndeterminate,
  hasMultiple = false,
  hasDescription,
  isFlexAlign = false,
  isHidden = false,
  ariaLabel,
  title,
  ...props
}) => (
  <>
    <$CheckboxInput
      {...props}
      title={safeFormattedIntlString(title)}
      onChange={onChange}
      isIndeterminate={isIndeterminate}
      checked={checked}
      type={type}
      role={type}
      name={name}
      id={name}
      disabled={disabled}
      ref={forwardedRef}
      danger={danger}
      value={value}
      data-testid={dataTestId}
      multiple={hasMultiple}
      $isHidden={isHidden}
      aria-label={ariaLabel}
    />
    <$StyledCheckbox
      danger={danger}
      disabled={disabled}
      $hasDescription={hasDescription}
      $isFlexAlign={isFlexAlign}
      $isHidden={isHidden}
    >
      <$CheckContainer>
        {!isIndeterminate && <CheckIcon size="20px" />}
        {isIndeterminate && <MinusIcon size="20px" />}
      </$CheckContainer>
    </$StyledCheckbox>
  </>
);

export default React.forwardRef<HTMLInputElement, CheckboxNakedProps>(
  (props, ref) => <CheckboxNaked forwardedRef={ref} {...props} />,
);
